





































import Vue, { PropType } from 'vue';
import {
    convertDatetimeToTz, convertDateToAmericanFormat, formatPrice, AMERICAN_DATE_FORMAT, TIME_FORMAT,
} from '../../lib/utils';

export default Vue.extend({
    props: {
        tenants: {
            type: Array,
        },
        ticketsHistoryData: {
            type: Array as PropType<object>,
        },
        isPaymentDisabled: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {

        const headers = [
            { text: 'Date', value: 'ticketDate', width: 125 },
            { text: 'PUtime', value: 'PUtime', width: 100 },
            { text: 'DOtime', value: 'DOtime', width: 100 },
            { text: 'PUstop', value: 'PUstop', width: 200 },
            { text: 'DOstop', value: 'DOstop', width: 200 },
            { text: 'Status', value: 'ticketStatus', width: 100 },
            { text: 'Name', value: 'name', width: 160 },
            { text: 'Email', value: 'email', width: 200 },
            {
                text: 'Booked at date', value: 'bookedAtDate', width: 150, sortable: false,
            },
            {
                text: 'Booked at time', value: 'bookedAtTime', width: 150, sortable: false,
            },
            {
                text: 'Used at date', value: 'usedAtDate', width: 150, sortable: false,
            },
            {
                text: 'Used at time', value: 'usedAtTime', width: 150, sortable: false,
            },
            {
                text: 'Cancelled at date', value: 'cancelledAtDate', width: 150, sortable: false,
            },
            {
                text: 'Cancelled at time', value: 'cancelledAtTime', width: 150, sortable: false,
            },
        ];

        if (!this.isPaymentDisabled) {
            headers.push({ text: 'Charge', value: 'chargeAmount', width: 150 });
            headers.push({ text: 'Credit', value: 'creditAmount', width: 150 });
        }

        if (this.tenants.length > 0) {
            // insert tenant column right after the Email column
            const fieldIndex = headers.findIndex((h: any) => h.text === 'Email');
            headers.splice(fieldIndex + 1, 0, {
                text: 'Tenant',
                value: 'tenantId',
                width: 300,
            });
        }

        return {
            AMERICAN_DATE_FORMAT,
            TIME_FORMAT,
            headers,
        };
    },
    methods: {
        convertDatetimeToTz,
        convertDateToAmericanFormat,
        formatPrice,
        getTenantName(item: any): string {
            const tenant: any = this.tenants.find((t: any) => t.tenantId === item?.tenantId);
            return tenant ? tenant.firmName : null;
        },
    },
});
